<template>
  <Breadcrumbs
    :breadcrumbs="breadcrumbsList"
    :is-category-link="true"
  />
</template>

<script lang="ts">
import type { Breadcrumb } from '~~/types/components/Breadcrumbs/Breadcrumb';
import { prepareBreadcrumb } from '~~/helpers/prepareBreadcrumb/prepareBreadcrumb';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { getBreadcrumbsFromProduct } from '~~/helpers/category/getBreadcrumbsFromProduct';

export default defineComponent({
  name: 'ProductBreadcrumbs',
  props: {
    product: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
  },
  setup(props) {

    const breadcrumbsList: ComputedRef<Breadcrumb[]> = computed(() => {

      const breadcrumbs = getBreadcrumbsFromProduct(props.product);
      let res = [];

      try {

        breadcrumbs.forEach((breadcrumb, index) => {

          if (!breadcrumb.name || !breadcrumb.slug) {

            /** if the breadcrumbs are incomplete, do not display any of them */
            res = [];

            return;
          
          }
          res.push(
            prepareBreadcrumb(breadcrumb.name, breadcrumb.slug, index),
          );
        
        });
      
      } catch (e) {

        /** reset after error occurs */
        res = [];
      
      }

      return res;
    
    });

    return {
      breadcrumbsList,
    };
  
  },
});
</script>
